import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/features/auth'
import { VipDashboard } from '@/components/vip/VipDashboard'

export function StatusPage() {
  const navigate = useNavigate()
  const { isAuthenticated, isLoading: authLoading } = useAuth()

  // Auth loading
  if (authLoading) {
    return (
      <div className="min-h-screen bg-pink-200 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-pink-500" />
      </div>
    )
  }

  // Not logged in
  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-pink-200 flex items-center justify-center px-4">
        <div className="bg-white/80 rounded-3xl shadow-lg p-8 max-w-sm w-full text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            You are currently not logged in
          </h1>
          <p className="text-sm text-gray-700 mb-8 leading-relaxed">
            Please return to this page after logging in to view your status.
          </p>
          <button
            onClick={() => navigate('/login?returnTo=/status')}
            className="w-full py-3 bg-pink-400 text-white font-semibold rounded-xl hover:bg-pink-500 transition-colors"
          >
            Log In
          </button>
        </div>
      </div>
    )
  }

  // Dashboard
  return (
    <div className="min-h-screen bg-pink-200 flex flex-col items-center px-4 py-8">
      <div className="w-full max-w-sm">
        <VipDashboard />
        <div className="mt-5 text-center">
          <button
            onClick={() => navigate('/welcome')}
            className="text-sm text-gray-700 hover:text-gray-900 font-medium transition-colors cursor-pointer"
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  )
}
